// extracted by mini-css-extract-plugin
module.exports = {"blue300":"#14267B","acceptBox":"AcceptBox_acceptBox___c7By","acceptBoxCheckbox":"AcceptBox_acceptBoxCheckbox__6HQ7X","acceptBoxLink":"AcceptBox_acceptBoxLink__SOkgo"};